import {
  BaseViewSchema,
  viewWithIdSchemas,
} from "@redotech/redo-views-common/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/** Analytics reports that keep one saved view per team. */
export const InventoryReportViewType = createEnum([
  "adjustment-report",
  "cost-of-goods-sold",
  "inventory-valuation",
]);
export type InventoryReportViewType = z.infer<typeof InventoryReportViewType>;

export const getInventoryReportView = {
  name: "getInventoryReportView" as const,
  input: z.object({ report: InventoryReportViewType }),
  /** Absent until the team saves one; the client starts from its defaults. */
  output: z.object({ view: viewWithIdSchemas["adjustment-report"].nullish() }),
};

export const saveInventoryReportView = {
  name: "saveInventoryReportView" as const,
  input: z.object({ report: InventoryReportViewType, view: BaseViewSchema }),
  output: z.object({}),
};
